import { render } from "./ProductsBanner.vue?vue&type=template&id=685ced4d&scoped=true"
import script from "./ProductsBanner.vue?vue&type=script&lang=js"
export * from "./ProductsBanner.vue?vue&type=script&lang=js"

import "./ProductsBanner.vue?vue&type=style&index=0&id=685ced4d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685ced4d"]])

export default __exports__